import { useLocation } from 'react-router-dom';

import type { SidebarSlots } from '../components/sidebar/sidebar';
import { resolveActiveItem } from '../nav-config';

/**
 * The id of the item that is current on the location path.
 *
 * @remarks
 * At most one item is current, chosen by `resolveActiveItem`, so a tool detail
 * page under `/catalog` lights up Software and not the catalog.
 *
 * @param slots - The items per slot, as `useNavSlots` resolves them.
 * @returns The id of the current item, or `undefined` when no item covers the
 *   path.
 *
 * @public
 */
export function useActiveItemId(slots: SidebarSlots): string | undefined {
  const { pathname } = useLocation();
  return resolveActiveItem(pathname, [
    ...slots.primary,
    ...slots.sections.flatMap(section => section.items),
    ...slots.utility,
    ...slots.other.items,
  ]);
}
